import React, { createContext, useContext, useCallback } from 'react';

interface ProgressContextType {
  isCompleted: (key: string) => boolean;
  markCompleted: (key: string) => void;
}

const ProgressContext = createContext<ProgressContextType>({
  isCompleted: () => false,
  markCompleted: () => {},
});

export function ProgressProvider({ children }: { children: React.ReactNode }) {
  const isCompleted = useCallback((key: string) => {
    return localStorage.getItem(key) === 'true';
  }, []);

  const markCompleted = useCallback((key: string) => {
    localStorage.setItem(key, 'true');
  }, []);

  return (
    <ProgressContext.Provider value={{ isCompleted, markCompleted }}>
      {children}
    </ProgressContext.Provider>
  );
}

export function useProgress() {
  return useContext(ProgressContext);
}
